import { useTranslation } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { queryClient } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";
import { AxiosError } from "axios";

import { usePatchControlsControlId } from "api/generated/controls/controls";
import { ControlUpdateFailedErrorDetails } from "api/generated/model";
import { STATUS_CODE_ERROR_OPERATION_FAILED } from "utils/errorCodes";

import { CONTROL_QUERY_KEY } from "../../queries/useControlQuery";
import { getMoneyTaskErrorMessage } from "../utils/moneyTaskErrorMessage";

export function useUpdateControlMutation() {
    const { t } = useTranslation();
    return usePatchControlsControlId({
        mutation: {
            onError: (error: AxiosError<ControlUpdateFailedErrorDetails>) => {
                if (
                    error.response?.status ===
                    STATUS_CODE_ERROR_OPERATION_FAILED
                ) {
                    const details = error.response.data;
                    switch (details.type) {
                        case "TriggerControlHaveIncompatibleAssignments":
                            emitNotification(
                                "error",
                                t(
                                    "CreateControl_Submit_IncompatibleAssignmentsError"
                                )
                            );
                            break;
                        case "TriggerControlHaveIncompatibleScheduling":
                            emitNotification(
                                "error",
                                t(
                                    "CreateControl_Submit_IncompatibleSchedulingError"
                                )
                            );
                            break;
                        case "InvalidAutoCompletion":
                            emitNotification(
                                "error",
                                t(
                                    "CreateControl_Submit_InvalidAutoCompletionError"
                                )
                            );
                            break;
                        case "InvalidMoneyTask":
                            emitNotification(
                                "error",
                                getMoneyTaskErrorMessage(t, details.error),
                                { duration: "DOUBLE" }
                            );
                            break;
                        default:
                            assertNever(details);
                    }
                } else {
                    emitNotification(
                        "error",
                        t("CreateControl_Submit_ServerError")
                    );
                }
            },
            onSuccess: () =>
                queryClient.invalidateQueries({
                    queryKey: [CONTROL_QUERY_KEY],
                }),
        },
    });
}
